module.exports = __webpack_public_path__ + "img/god.3d9fd439.png";